import { Event } from '../events'
import { EventTracker } from './EventTracker'

/**
 * An EventTracker that passes calls for each event method through to a set
 *   of underyling EventTrackers.
 */
export default class CompositeEventTracker extends EventTracker {
  private trackers: () => EventTracker[]

  public constructor(trackers: () => EventTracker[]) {
    super()

    this.trackers = trackers

    EventTracker.getEventTrackingMethodNames().map((eventTrackingMethodName) => {
      this[eventTrackingMethodName] = (event: Event<any>) => {
        this.trackers().forEach((tracker) => {
          tracker[eventTrackingMethodName](event as any)
        })
      }
    })
  }
}
